import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store';
import 'vuetify/dist/vuetify.min.css'
import moment from 'moment'
import LoadScript from 'vue-plugin-load-script';
import Axios from 'axios'
import "@/assets/global.css"
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'


Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$http = Axios;
Vue.use(LoadScript);
Vue.use(Chartkick.use(Chart))

new Vue({
            el: '#app',
            store,
            router,
            render: h => h(App)
        })
    